// InputContext.tsx
import React, { createContext, useContext, useState, ReactNode } from 'react';

// Define a interface para o contexto
interface InputContextType {
  inputValue: string;
  setInputValue: (value: string) => void;
}

// Crie o contexto com valor inicial undefined
const InputContext = createContext<InputContextType | undefined>(undefined);

// Crie o provedor do contexto
export const InputProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [inputValue, setInputValue] = useState<string>('f9a72986-c3ac-4f12-ba79-51c1d511d2b5');

  return (
    <InputContext.Provider value={{ inputValue, setInputValue }}>
      {children}
    </InputContext.Provider>
  );
};

// Hook personalizado para acessar o contexto
export const useInput = (): InputContextType => {
  const context = useContext(InputContext);
  if (!context) {
    throw new Error('useInput deve ser usado dentro de um InputProvider');
  }
  return context;
};
